import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { compressImage } from '../../utils/compressImage';
import BrandNav from '../../components/common/BrandNav';

const emptyItem = { name: '', name_ar: '', description: '', description_ar: '', price: '', image_path: '', image_thumb: '', icon: '', is_available: true, is_special: false };

const EMOJI_CATEGORIES = [
  { label: 'Hot Drinks', emojis: ['☕','🍵','🧉','🫖','🍶'] },
  { label: 'Cold Drinks', emojis: ['🧋','🥤','🧃','🍹','🍸','🍺','🍻','🥂','🍷','🧊','💧'] },
  { label: 'Breakfast', emojis: ['🥞','🧇','🍳','🥚','🧈','🥓','🥐','🍞','🥖','🥨','🧀'] },
  { label: 'Fast Food', emojis: ['🍔','🍟','🌭','🍕','🥪','🌮','🌯','🥙','🧆','🥚'] },
  { label: 'Main Dishes', emojis: ['🍗','🍖','🥩','🍱','🍛','🍜','🍝','🍲','🥘','🫕','🥗'] },
  { label: 'Seafood', emojis: ['🐟','🦐','🦞','🦀','🦑','🐙','🍣','🍤','🦪'] },
  { label: 'Rice & Bread', emojis: ['🍚','🍙','🍘','🥯','🫓','🥫','🧆'] },
  { label: 'Salads & Soups', emojis: ['🥗','🥣','🍲','🫕','🥬','🥦','🥕','🌽'] },
  { label: 'Desserts', emojis: ['🍰','🎂','🧁','🍩','🍪','🍫','🍬','🍭','🍮','🍯','🍦','🍧','🍨','🧃','🥧'] },
  { label: 'Fruits', emojis: ['🍎','🍊','🍋','🍇','🍓','🫐','🍑','🥭','🍍','🥥','🍌','🍒'] },
  { label: 'Extras', emojis: ['➕','⭐','🌶️','🧂','🫙','🧄','🫚','🥜','🍯','🥄','🍽','🫔'] },
];

// ── SVG Icon helpers ──────────────────────────────────────────────────────────
const PlusIco  = () => <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const EditIco  = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const CopyIco  = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>;
const MoveIco   = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 17 20 12 15 7"/><path d="M4 18v-2a4 4 0 014-4h12"/></svg>;
const CopyToIco = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/><line x1="16" y1="14" x2="16" y2="20"/><polyline points="14 18 16 20 18 18"/></svg>;
const TrashIco = () => <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>;

const IcoBtn = ({ onClick, title, danger, disabled, children, size = 32 }) => (
  <button
    type="button" onClick={onClick} title={title} disabled={disabled}
    style={{
      width: size, height: size, borderRadius: 8, flexShrink: 0,
      border: `1px solid ${danger ? '#FFCDD2' : '#E8E8E8'}`,
      background: danger ? '#FFF5F5' : '#FAFAFA',
      color: danger ? '#D32F2F' : '#555',
      cursor: disabled ? 'not-allowed' : 'pointer',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      opacity: disabled ? 0.38 : 1, transition: 'all 0.12s',
    }}
    onMouseOver={e => { if (!disabled) { e.currentTarget.style.background = danger ? '#FFEBEE' : '#EBEBEB'; e.currentTarget.style.borderColor = danger ? '#EF9A9A' : '#BDBDBD'; }}}
    onMouseOut={e => { if (!disabled) { e.currentTarget.style.background = danger ? '#FFF5F5' : '#FAFAFA'; e.currentTarget.style.borderColor = danger ? '#FFCDD2' : '#E8E8E8'; }}}
  >
    {children}
  </button>
);

function EmojiPicker({ onSelect, onClose }) {
  const [search, setSearch] = useState('');
  const allEmojis = EMOJI_CATEGORIES.flatMap(c => c.emojis);
  const filtered = search ? allEmojis.filter(() => true) : null; // just show categories when no search

  return (
    <div style={{ border: '1.5px solid #E0E0E0', borderRadius: 12, background: '#fff', overflow: 'hidden', marginTop: 8 }}>
      {/* Search */}
      <div style={{ padding: '10px 12px', borderBottom: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 8 }}>
        <input
          className="input"
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search emojis..."
          style={{ fontSize: 14, padding: '8px 12px' }}
          autoFocus
        />
        <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: '#999', flexShrink: 0 }}>✕</button>
      </div>

      {/* Emoji grid */}
      <div style={{ maxHeight: 260, overflowY: 'auto', padding: '8px 12px' }}>
        {search ? (
          /* Search results — show all emojis */
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {allEmojis.map((em, i) => (
              <button key={i} type="button" onClick={() => { onSelect(em); onClose(); }}
                style={{ fontSize: 24, background: 'none', border: 'none', cursor: 'pointer', padding: '4px 6px', borderRadius: 8, lineHeight: 1 }}
                onMouseOver={e => e.currentTarget.style.background = '#E3F2FD'}
                onMouseOut={e => e.currentTarget.style.background = 'none'}>
                {em}
              </button>
            ))}
          </div>
        ) : (
          /* Categorized */
          EMOJI_CATEGORIES.map(cat => (
            <div key={cat.label} style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: '#999', marginBottom: 6, textTransform: 'uppercase' }}>{cat.label}</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                {cat.emojis.map((em, i) => (
                  <button key={i} type="button" onClick={() => { onSelect(em); onClose(); }}
                    style={{ fontSize: 24, background: 'none', border: 'none', cursor: 'pointer', padding: '4px 6px', borderRadius: 8, lineHeight: 1 }}
                    onMouseOver={e => e.currentTarget.style.background = '#E3F2FD'}
                    onMouseOut={e => e.currentTarget.style.background = 'none'}>
                    {em}
                  </button>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default function MenuEditor() {
  const { brandId } = useParams();
  // Remember last visited brand for sidebar quick-navigation
  useEffect(() => { if (brandId) localStorage.setItem('pm_last_brand', brandId); }, [brandId]);
  const navigate = useNavigate();
  const [menu, setMenu] = useState(null);
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState(null);
  const [showCatModal, setShowCatModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [catForm, setCatForm] = useState({ name: '', name_ar: '', slide_only: false });
  const [itemForm, setItemForm] = useState(emptyItem);
  const [variants, setVariants] = useState([{ name: '', name_ar: '', price: '' }]);
  const [variantMode, setVariantMode] = useState('simple'); // 'simple' | 'same' | 'diff'
  const [sharedPrice, setSharedPrice] = useState('');
  const [uploading, setUploading] = useState(false);
  const [pendingFile, setPendingFile] = useState(null);   // compressed blob, not yet uploaded
  const [previewUrl, setPreviewUrl]   = useState(null);   // local blob: URL for preview
  const [brand, setBrand] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [photoMode, setPhotoMode] = useState('file'); // 'file' | 'icon'
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  // Category drag-to-reorder
  const [showCatSheet, setShowCatSheet] = useState(false);  // mobile bottom sheet
  const [dragIdx, setDragIdx] = useState(null);             // index being dragged
  const [dragOverIdx, setDragOverIdx] = useState(null);     // index being hovered
  const [showEditCatModal, setShowEditCatModal] = useState(false);
  const [editCatForm, setEditCatForm] = useState({ name: '', name_ar: '', cover_image: '', slide_only: false });
  const [editCatUploading, setEditCatUploading] = useState(false);
  // Right-click context menu on category items (PC view)
  const [catCtxMenu, setCatCtxMenu] = useState(null); // { catId, x, y } | null
  useEffect(() => {
    if (!catCtxMenu) return;
    const close = () => setCatCtxMenu(null);
    document.addEventListener('click', close);
    document.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      document.removeEventListener('click', close);
      document.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [catCtxMenu]);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [movingItem, setMovingItem] = useState(null);
  const [moveCopyMode, setMoveCopyMode] = useState('move'); // 'move' | 'copy'
  const [itemDragIdx, setItemDragIdx] = useState(null);
  const [itemDragOverIdx, setItemDragOverIdx] = useState(null);
  const catRowRefs = useRef({});                            // refs for touch hit detection
  const touchRef = useRef({ startIdx: null, currentIdx: null });
  const [displayLang, setDisplayLang] = useState(() => localStorage.getItem('menuEditorLang') || 'en');
  const [translating, setTranslating] = useState(false);
  const [importingExcel, setImportingExcel] = useState(false);
  const [importAppendMode, setImportAppendMode] = useState(null);
  const [showImportModeDialog, setShowImportModeDialog] = useState(false);
  const excelInputRef = useRef(null);

  // ── Quick-photo: click thumbnail in list to replace image ─────────────────
  const quickPhotoRef                 = useRef(null);
  const [quickPhotoItem, setQuickPhotoItem]           = useState(null);
  const [quickPhotoUploading, setQuickPhotoUploading] = useState(new Set());

  // ── Quick category-cover: click the small icon in the sidebar to upload
  // a cover photo for that category, the same way item thumbnails work.
  const quickCatCoverRef = useRef(null);
  const [quickCatCoverCat, setQuickCatCoverCat] = useState(null);
  const [quickCatCoverUploading, setQuickCatCoverUploading] = useState(new Set());

  // ── Header dropdown + Backup/Restore ─────────────────────────────────────
  const [showMenuDropdown, setShowMenuDropdown] = useState(false);
  const menuBtnRef = useRef(null);
  const restoreInputRef = useRef(null);
  const [restorePending, setRestorePending] = useState(null);

  // ── Per-item action dropdown (fixed-position portal) ─────────────────────
  const [openItemMenuId, setOpenItemMenuId] = useState(null);
  const [itemMenuPos,  setItemMenuPos]  = useState({ top: 0, right: 0 });
  const [itemMenuData, setItemMenuData] = useState(null); // the item whose menu is open

  const openItemMenu = (e, item) => {
    e.stopPropagation();
    if (openItemMenuId === item.id) { setOpenItemMenuId(null); setItemMenuData(null); return; }
    const rect       = e.currentTarget.getBoundingClientRect();
    const MENU_H     = 230; // ~6 rows × 37px + padding
    const MENU_W     = 210;

    // Horizontal: right-align to button, clamp so menu never overflows left edge
    const rawRight   = window.innerWidth - rect.right;
    const right      = Math.min(rawRight, window.innerWidth - MENU_W);

    // Vertical: open below by default; flip above when not enough space below
    const spaceBelow = window.innerHeight - rect.bottom - 8;
    const spaceAbove = rect.top - 8;
    const openAbove  = spaceBelow < MENU_H && spaceAbove >= MENU_H;

    const pos = openAbove
      ? { bottom: window.innerHeight - rect.top + 4, right, openAbove: true }
      : { top: rect.bottom + 4, right, openAbove: false };

    setItemMenuPos(pos);
    setItemMenuData(item);
    setOpenItemMenuId(item.id);
  };

  // Called when user puts finger on a ☰ handle.
  // Attaches window-level listeners (passive:false) so preventDefault works everywhere.
  const startTouchDrag = (e, idx) => {
    e.stopPropagation();
    touchRef.current = { startIdx: idx, currentIdx: idx };
    setDragIdx(idx);
    setDragOverIdx(idx);

    const onMove = (ev) => {
      ev.preventDefault();                          // block page/sheet scroll
      const touch = ev.touches[0];
      for (const [key, row] of Object.entries(catRowRefs.current)) {
        if (!row) continue;
        const rect = row.getBoundingClientRect();
        if (touch.clientY >= rect.top && touch.clientY <= rect.bottom) {
          const over = parseInt(key);
          touchRef.current.currentIdx = over;
          setDragOverIdx(over);
          break;
        }
      }
    };

    const onEnd = async () => {
      window.removeEventListener('touchmove', onMove, { passive: false });
      window.removeEventListener('touchend', onEnd);
      const { startIdx, currentIdx } = touchRef.current;
      touchRef.current = { startIdx: null, currentIdx: null };
      setDragIdx(null);
      setDragOverIdx(null);
      await reorderCats(startIdx, currentIdx);
    };

    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onEnd);
  };

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const toggleDisplayLang = () => {
    const newLang = displayLang === 'en' ? 'ar' : 'en';
    setDisplayLang(newLang);
    localStorage.setItem('menuEditorLang', newLang);
  };

  // ── Delete entire menu ───────────────────────────────────────────────────────
  const handleDeleteMenu = async () => {
    if (!window.confirm('Delete the entire menu? All categories and items will be permanently removed.')) return;
    if (!window.confirm('⚠️ This cannot be undone. Are you sure?')) return;
    try {
      await api.delete(`/categories/brand/${brandId}`);
      toast.success('Menu deleted');
      setCategories([]);
      setItems({});
      setActiveCategory(null);
    } catch (err) {
      toast.error('Failed to delete menu');
    }
  };

  // ── Import from Excel (standard template) ────────────────────────────────────
  // Two-step flow: open the dropdown → "Import from Excel" → opens a small
  // confirm dialog asking Replace vs Add → then native file picker. This way
  // the destructive choice (replace) is never a single accidental click.
  const startImport = () => {
    setShowMenuDropdown(false);
    setShowImportModeDialog(true);
  };
  const confirmImportMode = (append) => {
    setImportAppendMode(append);
    setShowImportModeDialog(false);
    setTimeout(() => excelInputRef.current?.click(), 50);
  };

  // ── Download Excel template ─────────────────────────────────────────────
  // Streams the bilingual EN/AR template from the server. Using fetch+blob so
  // we can carry the auth header (api default) — a plain <a download> would
  // hit the route without the JWT and 401.
  //
  // If the menu already has categories, ask the user whether they want a
  // blank template or one pre-filled with the brand's current menu (so they
  // can edit in Excel and re-import). Empty menus skip the prompt.
  const downloadTemplate = async () => {
    setShowMenuDropdown(false);

    let withData = false;
    if (categories.length > 0) {
      // Single window.confirm matches the rest of MenuEditor's UX. OK = include
      // current menu; Cancel = blank template. Both are valid actions.
      const totalItems = Object.values(items).reduce((s, arr) => s + (arr?.length || 0), 0);
      withData = window.confirm(
        `Your menu has ${categories.length} categories and ${totalItems} items.\n\n` +
        `OK    — download template filled with the current menu (edit & re-import).\n` +
        `Cancel — download a blank template.`
      );
    }

    const t = toast.loading('Preparing template…');
    try {
      const url = withData
        ? `/import/template?with_data=1&brand_id=${brandId}`
        : '/import/template';
      const res = await api.get(url, { responseType: 'blob' });
      const blobUrl = window.URL.createObjectURL(new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = withData
        ? `${(brand?.name || 'menu').replace(/[^A-Za-z0-9_-]+/g, '-').toLowerCase()}-menu.xlsx`
        : 'promedia-menu-template.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 5000);
      toast.success(withData ? 'Menu exported to Excel' : 'Template downloaded', { id: t });
    } catch (err) {
      toast.error('Failed to download template', { id: t });
    }
  };

  const handleExcelFileSelected = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = '';
    const append = importAppendMode;
    setImportingExcel(true);
    const t = toast.loading('Reading Excel file…');
    try {
      const formData = new FormData();
      formData.append('excel', file);
      const res = await api.post('/import/analyze-excel', formData);
      await api.post('/import/create', {
        brand_id: parseInt(brandId),
        menu_data: res.data.menu,
        append_mode: append
      });
      toast.success(`✅ ${res.data.summary.categories} categories, ${res.data.summary.items} items ${append ? 'added' : 'imported'}!`, { id: t });
      const catsRes = await api.get(`/categories?brand_id=${brandId}`);
      setCategories(catsRes.data);
      await loadItems(catsRes.data);
      if (!append && catsRes.data.length > 0) setActiveCategory(catsRes.data[0].id);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to import Excel', { id: t });
    } finally {
      setImportingExcel(false);
    }
  };

  // ── Quick-photo handlers ──────────────────────────────────────────────────
  const handleQuickPhotoClick = (item, e) => {
    e.stopPropagation();
    setQuickPhotoItem(item);
    setTimeout(() => quickPhotoRef.current?.click(), 30);
  };

  const handleQuickPhotoSelect = async (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file || !quickPhotoItem) return;
    const item = quickPhotoItem;
    setQuickPhotoItem(null);
    setQuickPhotoUploading(prev => new Set([...prev, item.id]));
    try {
      const compressed = await compressImage(file);
      const formData = new FormData();
      formData.append('image', compressed);
      formData.append('brand_id', brandId);
      formData.append('item_id', item.id);
      const uploadRes = await api.post('/upload/image', formData);
      await api.put(`/items/${item.id}`, {
        name: item.name, name_ar: item.name_ar || '',
        description: item.description || '', description_ar: item.description_ar || '',
        price: item.price || 0,
        image_path: uploadRes.data.url,
        image_thumb: uploadRes.data.thumbUrl || '',
        icon: item.icon || '',
        is_available: item.is_available !== false,
        is_special: item.is_special || false,
        category_id: item.category_id,
        sort_order: item.sort_order || 0,
        variants: item.variants || [],
      });
      const dp = uploadRes.data.displayUrl  || uploadRes.data.url;
      const dt = uploadRes.data.displayThumbUrl || uploadRes.data.thumbUrl || '';
      setItems(prev => {
        const list = prev[item.category_id] || [];
        return { ...prev, [item.category_id]: list.map(it => it.id === item.id ? {
          ...it,
          image_path:    uploadRes.data.url,           // clean URL — safe for DB writes
          image_thumb:   uploadRes.data.thumbUrl || '', // clean URL — safe for DB writes
          _displayPath:  dp,                           // cache-busted — for <img src> only
          _displayThumb: dt,
        } : it) };
      });
      toast.success('Photo updated!');
    } catch { toast.error('Failed to update photo'); }
    finally { setQuickPhotoUploading(prev => { const s = new Set(prev); s.delete(item.id); return s; }); }
  };

  // ── Quick category-cover handlers (sidebar icon → file picker) ────────────
  const handleQuickCatCoverClick = (cat, e) => {
    e.stopPropagation();
    setQuickCatCoverCat(cat);
    setTimeout(() => quickCatCoverRef.current?.click(), 30);
  };

  const handleQuickCatCoverSelect = async (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file || !quickCatCoverCat) return;
    const cat = quickCatCoverCat;
    setQuickCatCoverCat(null);
    setQuickCatCoverUploading(prev => new Set([...prev, cat.id]));
    try {
      // 1) Upload the new cover image
      const formData = new FormData();
      formData.append('image', file);
      formData.append('category_id', cat.id);
      if (brandId) formData.append('brand_id', brandId);
      const upRes = await api.post('/upload/category-cover', formData);
      const newUrl = upRes.data.url;

      // 2) Persist on the category record (PUT requires the full row to avoid
      // wiping name/sort/etc — same pattern as the Edit Category modal).
      await api.put(`/categories/${cat.id}`, {
        name: cat.name,
        name_ar: cat.name_ar || '',
        cover_image: newUrl,
        sort_order: cat.sort_order || 0,
        is_active: true,
        is_offer: !!cat.is_offer,
      });

      // 3) Update local state so the sidebar thumb refreshes immediately.
      // Cache-bust the URL so <img>/background reloads even if the path is reused.
      const display = newUrl + (newUrl.includes('?') ? '&' : '?') + 't=' + Date.now();
      setCategories(prev => prev.map(c => c.id === cat.id ? { ...c, cover_image: display } : c));
      toast.success('Cover photo updated!');
    } catch { toast.error('Failed to update cover'); }
    finally {
      setQuickCatCoverUploading(prev => { const s = new Set(prev); s.delete(cat.id); return s; });
    }
  };

  // ── Backup ────────────────────────────────────────────────────────────────
  const handleBackup = () => {
    try {
      const menu = {
        categories: categories.map(cat => ({
          name: cat.name || '', name_ar: cat.name_ar || '', icon: cat.icon || '', is_offer: cat.is_offer || false,
          items: (items[cat.id] || []).map(item => ({
            name: item.name || '', name_ar: item.name_ar || '',
            description: item.description || '', description_ar: item.description_ar || '',
            price: item.price || 0,
            image_path: item.image_path || '', image_thumb: item.image_thumb || '',
            icon: item.icon || '',
            is_available: item.is_available !== false, is_special: item.is_special || false,
            variants: (item.variants || []).map(v => ({ name: v.name || '', name_ar: v.name_ar || '', price: v.price || 0 })),
          })),
        })),
      };
      const totalItems = Object.values(items).reduce((s, a) => s + a.length, 0);
      const payload = { version: 1, timestamp: new Date().toISOString(), brand_id: parseInt(brandId), brand_name: brand?.name || '', summary: { categories: categories.length, items: totalItems }, menu };
      const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `menu-backup-${(brand?.name || 'menu').replace(/\s+/g, '-')}-${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success(`✅ Backed up ${categories.length} categories, ${totalItems} items`);
    } catch { toast.error('Backup failed'); }
  };

  // ── Restore ───────────────────────────────────────────────────────────────
  const handleRestoreSelected = async (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    try {
      const text = await file.text();
      const backup = JSON.parse(text);
      if (!backup.menu?.categories) throw new Error('invalid');
      setRestorePending(backup);
    } catch { toast.error('Invalid backup file — select a valid .json backup'); }
  };

  const handleRestoreConfirm = async () => {
    if (!restorePending) return;
    const backup = restorePending;
    setRestorePending(null);
    const t = toast.loading('Restoring menu…');
    try {
      await api.post('/import/create', { brand_id: parseInt(brandId), menu_data: backup.menu, append_mode: false });
      toast.success(`✅ Restored: ${backup.summary?.categories || '?'} categories, ${backup.summary?.items || '?'} items`, { id: t });
      const catsRes = await api.get(`/categories?brand_id=${brandId}`);
      setCategories(catsRes.data);
      await loadItems(catsRes.data);
      if (catsRes.data.length > 0) setActiveCategory(catsRes.data[0].id);
    } catch { toast.error('Restore failed', { id: t }); }
  };

  const handleTranslateAll = async () => {
    if (translating) return;
    if (!window.confirm('Translate all empty fields? This will fill English↔Arabic for all categories and items.')) return;
    
    setTranslating(true);
    const loadingToast = toast.loading('Translating menu... This may take a minute.');
    
    try {
      const allItems = Object.values(items).flat();
      const res = await api.post('/translate/translate-menu', {
        categories,
        items: allItems
      });

      if (res.data.success) {
        setCategories(res.data.categories);

        await Promise.all(res.data.categories.map(cat =>
          api.put(`/categories/${cat.id}`, {
            name: cat.name,
            name_ar: cat.name_ar || '',
            sort_order: cat.sort_order || 0,
            is_active: cat.is_active !== false,
            is_offer: !!cat.is_offer,
          })
        ));

        // ── Translate variant names (items that have variants with missing translations)
        const variantTranslations = {};
        const variantPseudoItems = [];
        res.data.items.forEach(item => {
          (item.variants || []).forEach((v, vi) => {
            const needsTranslation = (v.name && !v.name_ar) || (!v.name && v.name_ar);
            if (needsTranslation) {
              variantPseudoItems.push({ id: `v-${item.id}-${vi}`, name: v.name || '', name_ar: v.name_ar || '' });
            }
          });
        });
        if (variantPseudoItems.length > 0) {
          try {
            const vRes = await api.post('/translate/translate-menu', { categories: [], items: variantPseudoItems });
            if (vRes.data.success) {
              vRes.data.items.forEach(ti => { variantTranslations[ti.id] = ti; });
            }
          } catch (e) { console.warn('Variant translation failed', e); }
        }

        // Save items in chunks of 10 to avoid overwhelming the DB pool
        const allItemsToSave = res.data.items.map(item => {
          const updatedVariants = (item.variants || []).map((v, vi) => {
            const key = `v-${item.id}-${vi}`;
            const tr = variantTranslations[key];
            return tr ? { ...v, name: tr.name || v.name, name_ar: tr.name_ar || v.name_ar } : v;
          });
          return { item, updatedVariants };
        });
        // Save 3 at a time. The shared backend pool is capped at 10
        // connections with a 15 s statement_timeout, and each PUT runs a
        // multi-query transaction. Batches of 10 starve the pool and some
        // PUTs 500 with connection-timeout / query-timeout. 3 is the
        // safe sweet spot.
        for (let i = 0; i < allItemsToSave.length; i += 3) {
          await Promise.all(allItemsToSave.slice(i, i + 3).map(({ item, updatedVariants }) =>
            api.put(`/items/${item.id}`, {
              name: item.name,
              name_ar: item.name_ar || '',
              description: item.description || '',
              description_ar: item.description_ar || '',
              price: item.price !== undefined ? item.price : '',
              image_path: item.image_path || '',
              icon: item.icon || '',
              is_available: item.is_available !== false,
              is_special: item.is_special || false,
              category_id: item.category_id,
              sort_order: item.sort_order || 0,
              variants: updatedVariants,
            })
          ));
        }

        await refreshItems();
        toast.success('Translation complete!', { id: loadingToast });
      }
    } catch (err) {
      // Surface the real backend error so it's visible in the browser
      // console without needing pm2 logs.
      const serverMsg = err?.response?.data?.error || err?.message || 'unknown';
      const url = err?.config?.url || '';
      console.error('Translation error:', serverMsg, '| url:', url, '| full:', err);
      toast.error(`Translation failed: ${serverMsg}`, { id: loadingToast });
    } finally {
      setTranslating(false);
    }
  };

  const loadItems = async (cats) => {
    const allItems = {};
    await Promise.all(cats.map(async (cat) => {
      const res = await api.get(`/items?category_id=${cat.id}`);
      allItems[cat.id] = res.data;
    }));
    setItems(allItems);
  };

  const load = async () => {
    try {
      setLoading(true);
      const [catsRes, restRes] = await Promise.all([
        api.get(`/categories?brand_id=${brandId}`),
        api.get(`/brands/${brandId}`)
      ]);
      setCategories(catsRes.data);
      setBrand(restRes.data);
      if (catsRes.data.length > 0) {
        setActiveCategory(prev => prev || catsRes.data[0].id);
        await loadItems(catsRes.data);
      }
    } catch (err) {
      toast.error('Failed to load menu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [brandId]);

  const refreshItems = async () => {
    const catsRes = await api.get(`/categories?brand_id=${brandId}`);
    setCategories(catsRes.data);
    await loadItems(catsRes.data);
  };

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!catForm.name && !catForm.name_ar) {
      return toast.error('Please provide at least one name (English or Arabic)');
    }
    try {
      const result = await api.post('/categories', { brand_id: brandId, ...catForm, sort_order: categories.length });
      toast.success('Category added!');
      setShowCatModal(false);
      setCatForm({ name: '', name_ar: '', slide_only: false });
      const catsRes = await api.get(`/categories?brand_id=${brandId}`);
      setCategories(catsRes.data);
      setActiveCategory(result.data.id);
      await loadItems(catsRes.data);
    } catch (err) { toast.error('Error adding category'); }
  };

  const handleCreateOffer = async () => {
    try {
      const result = await api.post('/categories', {
        brand_id: brandId,
        name: 'Special Offers',
        name_ar: 'عروض خاصة',
        is_offer: true,
      });
      toast.success('Offer category created!');
      const catsRes = await api.get(`/categories?brand_id=${brandId}`);
      setCategories(catsRes.data);
      setActiveCategory(result.data.id);
      await loadItems(catsRes.data);
    } catch { toast.error('Error creating offer category'); }
  };

  const handleDeleteCategory = async (id) => {
    if (!window.confirm('Delete this category and all its items?')) return;
    await api.delete(`/categories/${id}`);
    toast.success('Deleted');
    const catsRes = await api.get(`/categories?brand_id=${brandId}`);
    setCategories(catsRes.data);
    setActiveCategory(catsRes.data[0]?.id || null);
    await loadItems(catsRes.data);
  };

  const handleDuplicateCategory = async (id) => {
    try {
      await api.post(`/categories/${id}/duplicate`);
      toast.success('Category duplicated!');
      await refreshItems();
    } catch (err) { toast.error('Duplicate failed'); }
  };

  const openEditCat = () => {
    if (!activeCat) return;
    setEditCatForm({
      name: activeCat.name,
      name_ar: activeCat.name_ar || '',
      cover_image: activeCat.cover_image || '',
      slide_only: !!activeCat.slide_only,
    });
    setShowEditCatModal(true);
  };

  const handleEditCatCoverUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !activeCategory) return;
    setEditCatUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('category_id', activeCategory);
      if (brandId) formData.append('brand_id', brandId);
      const res = await api.post('/upload/category-cover', formData);
      setEditCatForm(f => ({ ...f, cover_image: res.data.url + '?t=' + Date.now() }));
      toast.success('Cover photo uploaded!');
    } catch { toast.error('Upload failed'); }
    finally { setEditCatUploading(false); if (e.target) e.target.value = ''; }
  };

  const handleEditCategory = async (e) => {
    e.preventDefault();
    if (!editCatForm.name && !editCatForm.name_ar) {
      return toast.error('Please provide at least one name (English or Arabic)');
    }
    try {
      await api.put(`/categories/${activeCategory}`, {
        name: editCatForm.name, name_ar: editCatForm.name_ar,
        cover_image: editCatForm.cover_image || '',
        sort_order: activeCat?.sort_order || 0, is_active: true,
        is_offer: !!activeCat?.is_offer,
        slide_only: !!editCatForm.slide_only,
      });
      toast.success('Category updated!');
      setShowEditCatModal(false);
      await refreshItems();
    } catch { toast.error('Update failed'); }
  };

  const handleMoveItem = async (targetCatId) => {
    if (!movingItem || !targetCatId || targetCatId === activeCategory) return;
    try {
      await api.put(`/items/${movingItem.id}`, { ...movingItem, category_id: targetCatId });
      toast.success('Item moved!');
      setShowMoveModal(false);
      setMovingItem(null);
      await refreshItems();
    } catch { toast.error('Move failed'); }
  };

  const handleCopyItemTo = async (targetCatId) => {
    if (!movingItem || !targetCatId) return;
    try {
      await api.post('/items', {
        category_id: targetCatId,
        name: movingItem.name, name_ar: movingItem.name_ar || '',
        description: movingItem.description || '', description_ar: movingItem.description_ar || '',
        price: movingItem.price || 0,
        image_path: movingItem.image_path || '', image_thumb: movingItem.image_thumb || '',
        icon: movingItem.icon || '',
        is_available: movingItem.is_available !== false,
        is_special: movingItem.is_special || false,
        variants: movingItem.variants || [],
      });
      toast.success('Item copied!');
      setShowMoveModal(false);
      setMovingItem(null);
      await refreshItems();
    } catch { toast.error('Copy failed'); }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const compressed = await compressImage(file);
      // Revoke previous blob URL to avoid memory leak
      if (previewUrl?.startsWith('blob:')) URL.revokeObjectURL(previewUrl);
      const localUrl = URL.createObjectURL(compressed);
      setPendingFile(compressed);
      setPreviewUrl(localUrl);
      // Clear any existing saved image — new file will be uploaded on Save
      setItemForm(f => ({ ...f, image_path: '', image_thumb: '', icon: '' }));
    } catch { toast.error('Failed to process image'); }
    finally { setUploading(false); }
  };

  const clearPendingFile = () => {
    if (previewUrl?.startsWith('blob:')) URL.revokeObjectURL(previewUrl);
    setPendingFile(null);
    setPreviewUrl(null);
  };

  const handleAddItem = async (e) => {
    e.preventDefault();
    if (!itemForm.name && !itemForm.name_ar) {
      return toast.error('Please provide at least one name (English or Arabic)');
    }
    if (variantMode === 'simple') {
      if (!variants[0]?.price) return toast.error('Please add a price');
    } else if (variantMode === 'same') {
      if (!sharedPrice) return toast.error('Please add a price for variants');
      if (variants.some(v => !v.name && !v.name_ar)) return toast.error('All variants need a name (English or Arabic)');
    } else {
      if (variants.some(v => (!v.name && !v.name_ar) || !v.price)) return toast.error('All variants need a name and price');
    }
    try {
      const payloadVariants = variantMode === 'simple' ? []
        : variantMode === 'same' ? variants.map(v => ({ ...v, price: sharedPrice }))
        : variants;
      const payloadPrice = variantMode === 'simple' ? variants[0].price
        : variantMode === 'same' ? sharedPrice
        : 0;
      const payload = {
        ...itemForm,
        category_id: activeCategory,
        price: payloadPrice,
        variants: payloadVariants,
      };

      // If a file was selected but not yet uploaded, do it now (on Save only)
      if (pendingFile) {
        setUploading(true);
        try {
          const formData = new FormData();
          formData.append('image', pendingFile, 'image.jpg');
          formData.append('brand_id', brandId);
          // Pass item_id when editing so the server uses a deterministic
          // per-item filename (brand-item-{id}.png) — guaranteed no collision.
          if (editingItem?.id) formData.append('item_id', editingItem.id);
          const uploadRes = await api.post('/upload/image', formData);
          // Store clean URLs in DB (no ?v=) — used for file deletion comparison.
          // Use cache-busted URLs only for immediate display so browser fetches fresh file.
          payload.image_path  = uploadRes.data.url;
          payload.image_thumb = uploadRes.data.thumbUrl || '';
          payload._displayPath  = uploadRes.data.displayUrl  || uploadRes.data.url;
          payload._displayThumb = uploadRes.data.displayThumbUrl || uploadRes.data.thumbUrl || '';
        } finally { setUploading(false); }
      }

      if (editingItem) {
        const res = await api.put(`/items/${editingItem.id}`, payload);
        toast.success('Item updated!');
        // Update item in-place — never touches its sort position.
        // Use cache-busted display URLs if a new photo was just uploaded so the
        // browser immediately fetches the fresh file instead of showing the cached old one.
        const updatedItem = {
          ...res.data,  // always has clean URLs from DB
          ...(payload._displayPath  ? { _displayPath:  payload._displayPath  } : {}),
          ...(payload._displayThumb ? { _displayThumb: payload._displayThumb } : {}),
        };
        setItems(prev => {
          const catItems = prev[activeCategory] || [];
          return {
            ...prev,
            [activeCategory]: catItems.map(it =>
              it.id === editingItem.id ? updatedItem : it
            ),
          };
        });
      } else {
        await api.post('/items', payload);
        toast.success('Item added!');
        await refreshItems();
      }
      clearPendingFile();
      setShowItemModal(false);
      setEditingItem(null);
      setItemForm(emptyItem);
      setVariants([{ name: '', name_ar: '', price: '' }]);
      setVariantMode('simple');
      setSharedPrice('');
      setShowEmojiPicker(false);
    } catch (err) { toast.error('Error saving item'); }
  };

  const handleDeleteItem = async (itemId) => {
    if (!window.confirm('Delete this item?')) return;
    await api.delete(`/items/${itemId}`);
    toast.success('Deleted');
    await refreshItems();
  };

  const handleDuplicateItem = async (itemId) => {
    try {
      await api.post(`/items/${itemId}/duplicate`);
      toast.success('Item duplicated!');
      await refreshItems();
    } catch (err) { toast.error('Duplicate failed'); }
  };

  const openEditItem = (item) => {
    clearPendingFile();
    setEditingItem(item);
    setItemForm({ ...item, icon: item.icon || '' });
    if (item.variants?.length > 0) {
      const allSame = item.variants.every(v => String(v.price) === String(item.variants[0].price));
      if (allSame) {
        setVariantMode('same');
        setSharedPrice(String(item.variants[0].price || ''));
        setVariants(item.variants.map(v => ({ name: v.name, name_ar: v.name_ar || '', price: '' })));
      } else {
        setVariantMode('diff');
        setSharedPrice('');
        setVariants(item.variants);
      }
    } else {
      setVariantMode('simple');
      setSharedPrice('');
      setVariants([{ name: '', name_ar: '', price: item.price || '' }]);
    }
    setPhotoMode('file');
    setShowEmojiPicker(false);
    setShowItemModal(true);
  };

  const openAddItem = () => {
    clearPendingFile();
    setEditingItem(null);
    setItemForm(emptyItem);
    setVariantMode('simple');
    setSharedPrice('');
    setVariants([{ name: '', name_ar: '', price: '' }]);
    setPhotoMode('file');
    setShowEmojiPicker(false);
    setShowItemModal(true);
  };

  const addVariant = () => setVariants(v => [...v, { name: '', name_ar: '', price: '' }]);
  const removeVariant = (i) => setVariants(v => v.length > 1 ? v.filter((_, idx) => idx !== i) : v);
  const updateVariant = (i, field, value) => setVariants(v => v.map((item, idx) => idx === i ? { ...item, [field]: value } : item));

  const activeCat = categories.find(c => c.id === activeCategory);

  const reorderCats = async (fromIdx, toIdx) => {
    if (fromIdx === null || toIdx === null || fromIdx === toIdx) return;
    const newCats = [...categories];
    const [moved] = newCats.splice(fromIdx, 1);
    newCats.splice(toIdx, 0, moved);
    const updated = newCats.map((c, i) => ({ ...c, sort_order: i }));
    setCategories(updated);
    setActiveCategory(updated[toIdx].id);
    try {
      await Promise.all(updated.map((cat, i) =>
        api.put(`/categories/${cat.id}`, { name: cat.name, name_ar: cat.name_ar || '', sort_order: i, is_active: cat.is_active !== false, is_offer: !!cat.is_offer })
      ));
    } catch { toast.error('Reorder failed'); await refreshItems(); }
  };

  const reorderItems = async (fromIdx, toIdx) => {
    if (fromIdx === null || toIdx === null || fromIdx === toIdx) return;
    const catItems = [...(items[activeCategory] || [])];
    const [moved] = catItems.splice(fromIdx, 1);
    catItems.splice(toIdx, 0, moved);
    const updated = catItems.map((item, i) => ({ ...item, sort_order: i }));
    setItems(prev => ({ ...prev, [activeCategory]: updated }));
    try {
      await Promise.all(updated.map((item, i) =>
        api.put(`/items/${item.id}`, {
          name: item.name, name_ar: item.name_ar || '',
          description: item.description || '', description_ar: item.description_ar || '',
          price: item.price || '',
          image_path:  (item.image_path  || '').split('?')[0],  // strip ?v= cache buster
          image_thumb: (item.image_thumb || '').split('?')[0],
          icon: item.icon || '',
          is_available: item.is_available !== false, is_special: item.is_special || false,
          category_id: item.category_id, sort_order: i,
          variants: item.variants || [],
        })
      ));
    } catch { toast.error('Reorder failed'); await refreshItems(); }
  };

  // ── Per-item ☰ trigger button (dropdown rendered at page level) ──────────
  const ItemMenu = ({ item, size = 32 }) => {
    const isOpen = openItemMenuId === item.id;
    return (
      <button
        onClick={e => openItemMenu(e, item)}
        style={{
          width: size, height: size, borderRadius: 8, border: '1px solid #E8E8E8',
          background: isOpen ? '#F0F0F0' : '#FAFAFA', cursor: 'pointer', flexShrink: 0,
          display: 'inline-flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', gap: 3.5, padding: 0, transition: 'background 0.12s',
        }}
        onMouseOver={e => { if (!isOpen) e.currentTarget.style.background = '#EBEBEB'; }}
        onMouseOut={e => { if (!isOpen) e.currentTarget.style.background = isOpen ? '#F0F0F0' : '#FAFAFA'; }}
      >
        <span style={{ display: 'block', width: 12, height: 1.5, background: '#666', borderRadius: 1 }} />
        <span style={{ display: 'block', width: 12, height: 1.5, background: '#666', borderRadius: 1 }} />
        <span style={{ display: 'block', width: 12, height: 1.5, background: '#666', borderRadius: 1 }} />
      </button>
    );
  };

  // Small icon button used in mobile card
  const IconBtn = ({ onClick, danger, children }) => (
    <button
      onClick={onClick}
      style={{
        width: 32, height: 32, borderRadius: 8, border: 'none', cursor: 'pointer',
        background: danger ? '#FFEBEE' : '#F5F5F5',
        color: danger ? '#C62828' : '#555',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 15, flexShrink: 0
      }}
    >
      {children}
    </button>
  );

  // ── Clickable thumbnail with hover-overlay camera icon ───────────────────
  const QuickThumb = ({ item, size = 72, radius = 10 }) => {
    const [hov, setHov] = useState(false);
    const uploading = quickPhotoUploading.has(item.id);
    return (
      <div
        onClick={e => handleQuickPhotoClick(item, e)}
        onMouseEnter={() => setHov(true)}
        onMouseLeave={() => setHov(false)}
        title="Click to change photo"
        style={{
          position: 'relative', width: size, height: size, flexShrink: 0,
          borderRadius: radius, overflow: 'hidden', cursor: 'pointer',
          background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        {/* Content */}
        {item.image_path ? (
          <img src={item._displayThumb || item._displayPath || item.image_thumb || item.image_path} alt={item.name}
            style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
        ) : item.icon && item.icon !== '🍽' ? (
          <span style={{ fontSize: size * 0.47 }}>{item.icon}</span>
        ) : brand?.logo_path ? (
          <img src={brand.logo_path} alt=""
            style={{ width: size * 0.72, height: size * 0.72, objectFit: 'contain', opacity: 0.45 }} />
        ) : (
          <span style={{ fontSize: size * 0.39, color: '#ddd' }}>🍽</span>
        )}
        {/* Hover / uploading overlay */}
        {(hov || uploading) && (
          <div style={{
            position: 'absolute', inset: 0,
            background: uploading ? 'rgba(0,0,0,0.55)' : 'rgba(0,0,0,0.40)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'background 0.15s',
          }}>
            {uploading ? (
              <div style={{ width: 22, height: 22, borderRadius: '50%', border: '2.5px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', animation: '_imgSpin 0.75s linear infinite' }} />
            ) : (
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/>
                <circle cx="12" cy="13" r="4"/>
              </svg>
            )}
          </div>
        )}
      </div>
    );
  };

  // Item display helper
  const ItemDisplay = ({ item, mobile }) => {
    if (mobile) return (
      <div style={{
        background: '#fff', borderRadius: 14, border: '1px solid #F0F0F0',
        boxShadow: '0 1px 5px rgba(0,0,0,0.06)', overflow: 'hidden',
        display: 'flex', gap: 0
      }}>
        {/* Left: clickable thumbnail strip */}
        <QuickThumb item={item} size={72} radius={0} />

        {/* Right: content */}
        <div style={{ flex: 1, minWidth: 0, padding: '10px 12px 10px 12px' }}>

          {/* Row 1: name + action buttons */}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 6, marginBottom: 3 }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                <span style={{ fontWeight: 700, fontSize: 14, color: '#1A1A1A', lineHeight: 1.3, fontFamily: 'Cairo, sans-serif' }}>
                  {displayLang === 'ar' ? (item.name_ar || item.name) : item.name}
                </span>
                {item.is_special && <span style={{ fontSize: 10, background: '#FFF3E0', color: '#E65100', padding: '1px 6px', borderRadius: 8, fontWeight: 600 }}>★</span>}
                {!item.is_available && <span style={{ fontSize: 10, background: '#FFEBEE', color: '#C62828', padding: '1px 6px', borderRadius: 8, fontWeight: 600 }}>Off</span>}
              </div>
            </div>
            {/* Action menu — top right */}
            <ItemMenu item={item} size={30} />
          </div>

          {/* Row 2: description */}
          {(displayLang === 'ar' ? (item.description_ar || item.description) : item.description) && (
            <div style={{ fontSize: 12, color: '#888', marginBottom: 5, lineHeight: 1.35, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', fontFamily: 'Arial, sans-serif' }}>
              {displayLang === 'ar' ? (item.description_ar || item.description) : item.description}
            </div>
          )}

          {/* Row 3: price / variants */}
          {item.variants?.length > 0 ? (
            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
              {item.variants.map((v, i) => (
                <span key={i} style={{ fontSize: 11, background: '#E3F2FD', color: '#1565C0', padding: '2px 7px', borderRadius: 8, fontWeight: 600, fontFamily: 'Arial, sans-serif' }}>
                  {displayLang === 'ar' ? (v.name_ar || v.name) : v.name}: {v.price}
                </span>
              ))}
            </div>
          ) : (
            <div style={{ fontWeight: 700, color: '#2196F3', fontSize: 14 }}>{item.price} EGP</div>
          )}
        </div>
      </div>
    );

    // Desktop card
    return (
      <div className="card" style={{ padding: 16, display: 'flex', gap: 12, alignItems: 'center' }}>
        {/* Drag handle */}
        <div style={{ cursor: 'grab', color: '#C8C8C8', fontSize: 16, flexShrink: 0, userSelect: 'none', padding: '4px 2px' }}>☰</div>
        {/* Clickable thumbnail */}
        <QuickThumb item={item} size={72} radius={10} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 2 }}>
            <span style={{ fontWeight: 600, fontSize: 15, fontFamily: 'Cairo, sans-serif' }}>
              {displayLang === 'ar' ? (item.name_ar || item.name) : item.name}
            </span>
            {item.is_special && <span className="badge badge-blue">Special</span>}
            {!item.is_available && <span className="badge badge-red">Unavailable</span>}
          </div>
          {(displayLang === 'ar' ? (item.description_ar || item.description) : item.description) && <div style={{ fontSize: 12, color: '#757575', marginBottom: 4, overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', fontFamily: 'Arial, sans-serif' }}>{displayLang === 'ar' ? (item.description_ar || item.description) : item.description}</div>}
          {item.variants?.length > 0 ? (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              {item.variants.map((v, i) => (
                <span key={i} style={{ fontSize: 12, background: '#E3F2FD', color: '#1565C0', padding: '2px 7px', borderRadius: 10, fontWeight: 500, fontFamily: 'Arial, sans-serif' }}>{displayLang === 'ar' ? (v.name_ar || v.name) : v.name}: {v.price} EGP</span>
              ))}
            </div>
          ) : (
            <div style={{ fontWeight: 700, color: '#2196F3', fontSize: 15 }}>{item.price} EGP</div>
          )}
        </div>
        <ItemMenu item={item} />
      </div>
    );
  };

  if (loading) return <div className="spinner" />;

  return (
    <div className="page" style={{ paddingBottom: 40, fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div className="page-header">
        <div>
          <BrandNav brandId={brandId} subPath="menu" backLabel="Brands" backPath="/" backKey="/" />
          <h1 className="page-title">
            Menu Editor
            {brand && <span style={{ color: '#F44336', fontSize: 15, fontWeight: 700, marginLeft: 8 }}>— {brand.name}{brand.name_ar ? ' · ' + brand.name_ar : ''}</span>}
          </h1>
        </div>
        {/* ── Hidden file inputs ── */}
        <input ref={quickPhotoRef}    type="file" accept="image/*"          style={{ display: 'none' }} onChange={handleQuickPhotoSelect} />
        <input ref={quickCatCoverRef} type="file" accept="image/*"          style={{ display: 'none' }} onChange={handleQuickCatCoverSelect} />
        <input ref={excelInputRef}    type="file" accept=".xlsx,.xls,.csv"  style={{ display: 'none' }} onChange={handleExcelFileSelected} />
        <input ref={restoreInputRef}  type="file" accept=".json"            style={{ display: 'none' }} onChange={handleRestoreSelected} />

        {/* ── Language toggle (always visible) ── */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button
          className="btn btn-outline btn-sm"
          onClick={toggleDisplayLang}
          title={`Switch to ${displayLang === 'en' ? 'Arabic' : 'English'} display`}
          style={{ height: 38, minWidth: 44, padding: '0 10px', fontSize: 13, fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, fontFamily: displayLang === 'ar' ? 'Cairo' : 'inherit', letterSpacing: 0.5 }}
        >
          {displayLang === 'en' ? 'EN' : 'AR'}
        </button>

        {/* ── ☰ Menu dropdown ── */}
        <div style={{ position: 'relative' }}>
          <button
            ref={menuBtnRef}
            onClick={() => setShowMenuDropdown(v => !v)}
            style={{ height: 38, minWidth: 44, padding: '0 10px', borderRadius: 10, border: 'none', background: showMenuDropdown ? '#16A34A' : '#22C55E', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 3, flexDirection: 'column', transition: 'background 0.15s' }}
            title="Menu options"
            onMouseOver={e => e.currentTarget.style.background = '#16A34A'}
            onMouseOut={e => { if (!showMenuDropdown) e.currentTarget.style.background = '#22C55E'; }}
          >
            <span style={{ display: 'block', width: 16, height: 2, background: '#fff', borderRadius: 2 }} />
            <span style={{ display: 'block', width: 16, height: 2, background: '#fff', borderRadius: 2 }} />
            <span style={{ display: 'block', width: 16, height: 2, background: '#fff', borderRadius: 2 }} />
          </button>

          {showMenuDropdown && (() => {
            const DividerLine = () => <div style={{ height: 1, background: '#F0F0F0', margin: '4px 0' }} />;
            const SLabel = ({ children }) => (
              <div style={{ padding: '8px 14px 4px', fontSize: 10, fontWeight: 700, color: '#AAA', textTransform: 'uppercase', letterSpacing: 0.8 }}>{children}</div>
            );
            const MI = ({ icon, label, sub, onClick: onClickItem, danger, disabled, highlight }) => (
              <button
                onClick={disabled ? undefined : onClickItem}
                disabled={disabled}
                style={{
                  width: '100%', padding: '9px 14px', border: 'none', background: 'none',
                  cursor: disabled ? 'default' : 'pointer', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 10,
                  opacity: disabled ? 0.45 : 1,
                  borderRadius: 8, margin: '1px 4px', width: 'calc(100% - 8px)',
                }}
                onMouseOver={e => { if (!disabled) e.currentTarget.style.background = danger ? '#FFF5F5' : highlight ? '#FFF8E1' : '#F5F5F5'; }}
                onMouseOut={e => { e.currentTarget.style.background = 'none'; }}
              >
                <span style={{ fontSize: 18, lineHeight: 1, flexShrink: 0, width: 22, textAlign: 'center' }}>{icon}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: danger ? '#C62828' : '#222', lineHeight: 1.3 }}>{label}</div>
                  {sub && <div style={{ fontSize: 11, color: '#999', marginTop: 1 }}>{sub}</div>}
                </div>
              </button>
            );
            // Compute viewport-clamped fixed position from button rect so the
            // dropdown is always fully on-screen (regardless of where the button
            // sits — top-right on PC or top-left on mobile).
            const W = 268, MARGIN = 8;
            const r = menuBtnRef.current?.getBoundingClientRect();
            const dropW = Math.min(W, window.innerWidth - MARGIN * 2);
            const top = r ? r.bottom + 4 : 60;
            // Prefer right-aligning the dropdown to the button's right edge,
            // but clamp so the left side never goes off-screen.
            let left = r ? (r.right - dropW) : MARGIN;
            if (left < MARGIN) left = MARGIN;
            if (left + dropW > window.innerWidth - MARGIN) left = window.innerWidth - dropW - MARGIN;
            return (
              <>
                <div style={{ position: 'fixed', inset: 0, zIndex: 1099 }} onClick={() => setShowMenuDropdown(false)} />
                {ReactDOM.createPortal(
                  <div style={{
                    position: 'fixed', top, left, width: dropW, zIndex: 1100,
                    background: '#fff', border: '1.5px solid #E8E8E8', borderRadius: 14,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.14)', padding: '6px 0',
                    maxHeight: `calc(100vh - ${top + 16}px)`, overflowY: 'auto',
                  }}>
                    <SLabel>Edit</SLabel>
                    <MI icon="💰" label="Price List Editor" sub="Edit all prices in a table view" highlight onClick={() => { setShowMenuDropdown(false); navigate(`/brands/${brandId}/price-list`); }} />
                    <MI icon="🌐" label="Translate All" sub="Auto-fill empty EN ↔ AR fields" disabled={translating} onClick={() => { setShowMenuDropdown(false); handleTranslateAll(); }} />

                    <DividerLine />
                    <SLabel>Excel</SLabel>
                    <MI icon="📊" label="Import from Excel" sub="Upload a filled .xlsx — choose Replace or Add next" onClick={() => startImport()} disabled={importingExcel} />
                    <MI icon="📥" label="Download Template" sub="Empty bilingual (EN + AR) .xlsx to fill in" onClick={() => downloadTemplate()} />

                    <DividerLine />
                    <SLabel>Backup &amp; Restore</SLabel>
                    <MI icon="💾" label="Backup to File" sub="Download full menu as .json" onClick={() => { setShowMenuDropdown(false); handleBackup(); }} />
                    <MI icon="📂" label="Restore from Backup" sub="Replace menu from a .json backup file" onClick={() => { setShowMenuDropdown(false); setTimeout(() => restoreInputRef.current?.click(), 50); }} />

                    <DividerLine />
                    <SLabel>View</SLabel>
                    <MI icon="🎨" label="Slide Builder" sub="Design TV menu boards from your items" onClick={() => { setShowMenuDropdown(false); navigate(`/brands/${brandId}/slides`); }} />
                    <MI icon="⬛" label="QR Code" sub="View and share menu QR code" onClick={() => { setShowMenuDropdown(false); navigate(`/brands/${brandId}/qr`); }} />

                    <DividerLine />
                    <MI icon="🗑️" label="Delete Entire Menu" sub="Permanently remove all categories & items" danger onClick={() => { setShowMenuDropdown(false); handleDeleteMenu(); }} />
                  </div>,
                  document.body
                )}
              </>
            );
          })()}
        </div>
        </div>{/* end lang+menu flex wrapper */}
      </div>

      {/* MOBILE */}
      {isMobile ? (
        <div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 16, alignItems: 'center' }}>
            {/* Custom category selector — opens bottom sheet */}
            <div
              style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 14px', height: 48, background: '#fff', border: '1.5px solid #E0E0E0', borderRadius: 10, cursor: 'pointer', fontSize: 15 }}
              onClick={() => categories.length > 0 && setShowCatSheet(true)}
            >
              {categories.length === 0 ? (
                <span style={{ color: '#bbb' }}>No categories yet</span>
              ) : (
                <>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, marginRight: 8, fontFamily: 'Cairo, sans-serif' }}>
                    {displayLang === 'ar' ? (activeCat?.name_ar || activeCat?.name) : activeCat?.name} ({items[activeCategory]?.length || 0})
                  </span>
                  <span style={{ color: '#999', fontSize: 13, flexShrink: 0 }}>☰</span>
                </>
              )}
            </div>
            <button className="btn btn-primary btn-sm" onClick={() => { setShowCatModal(true); setCatForm({ name: '', name_ar: '', slide_only: false }); }} style={{ flexShrink: 0 }}>+ Cat</button>
          </div>

          {/* ── Mobile bottom sheet: category list with touch drag ── */}
          {showCatSheet && (
            <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 300 }} onClick={() => setShowCatSheet(false)}>
              <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: '#fff', borderRadius: '20px 20px 0 0', maxHeight: '72vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>

                {/* Sheet header */}
                <div style={{ padding: '14px 20px 10px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                  <span style={{ fontWeight: 700, fontSize: 16 }}>Categories</span>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <span style={{ fontSize: 11, color: '#aaa' }}>hold ☰ to reorder</span>
                    <button onClick={() => setShowCatSheet(false)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#999', lineHeight: 1 }}>✕</button>
                  </div>
                </div>

                {/* Scrollable list with touch-drag */}
                <div style={{ overflowY: dragIdx !== null ? 'hidden' : 'auto', flex: 1, WebkitOverflowScrolling: 'touch' }}>
                  {categories.map((cat, idx) => (
                    <div
                      key={cat.id}
                      ref={el => { catRowRefs.current[idx] = el; }}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 12,
                        padding: '0 20px',
                        height: 60,
                        background: dragIdx === idx ? '#f0f7ff' : dragOverIdx === idx && dragIdx !== idx ? '#E3F2FD' : activeCategory === cat.id ? '#F0F7FF' : '#fff',
                        opacity: dragIdx === idx ? 0.5 : 1,
                        borderBottom: '1px solid #F5F5F5',
                        borderLeft: dragOverIdx === idx && dragIdx !== idx ? '3px solid #2196F3' : '3px solid transparent',
                        transition: 'background 0.1s, border-color 0.1s',
                      }}
                    >
                      {/* Drag handle */}
                      <div
                        onTouchStart={e => startTouchDrag(e, idx)}
                        style={{ cursor: 'grab', touchAction: 'none', color: '#CCC', fontSize: 22, flexShrink: 0, padding: '8px 4px', userSelect: 'none' }}
                      >
                        ☰
                      </div>

                      {/* Name — tap to select */}
                      <div
                        onClick={() => { setActiveCategory(cat.id); setShowCatSheet(false); }}
                        style={{ flex: 1, minWidth: 0, cursor: 'pointer' }}
                      >
                        <div style={{ fontWeight: activeCategory === cat.id ? 700 : 500, fontSize: 15, color: activeCategory === cat.id ? '#2196F3' : '#222', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: 'Cairo, sans-serif' }}>
                          {displayLang === 'ar' ? (cat.name_ar || cat.name) : cat.name}
                        </div>
                      </div>

                      {/* Item count */}
                      <span style={{ flexShrink: 0, fontSize: 12, background: activeCategory === cat.id ? '#2196F3' : '#EEEEEE', color: activeCategory === cat.id ? '#fff' : '#666', padding: '3px 9px', borderRadius: 12, fontWeight: 600, minWidth: 28, textAlign: 'center' }}>
                        {items[cat.id]?.length || 0}
                      </span>
                    </div>
                  ))}
                </div>

              </div>
            </div>
          )}

          {activeCat && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, gap: 8 }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={{ fontWeight: 700, fontSize: 16, fontFamily: 'Cairo, sans-serif' }}>
                  {displayLang === 'ar' ? (activeCat.name_ar || activeCat.name) : activeCat.name}
                </span>
              </div>
              <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                <IcoBtn size={34} title="Edit category" onClick={openEditCat}><EditIco/></IcoBtn>
                <IcoBtn size={34} title="Duplicate category" onClick={() => handleDuplicateCategory(activeCategory)}><CopyIco/></IcoBtn>
                <IcoBtn size={34} title="Delete category" danger onClick={() => handleDeleteCategory(activeCategory)}><TrashIco/></IcoBtn>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button
                    onClick={handleCreateOffer}
                    title="Add Offer"
                    style={{ padding: '6px 10px', borderRadius: 8, border: '1.5px solid #F9A825', background: '#FFF8E1', color: '#E65100', fontWeight: 600, fontSize: 13, cursor: 'pointer' }}
                  >🏷️</button>
                  <button className="btn btn-primary btn-sm" onClick={openAddItem}>+ Item</button>
                </div>
              </div>
            </div>
          )}

          {!activeCategory ? (
            <div className="empty-state card"><h3>No categories yet</h3><button className="btn btn-primary" style={{ marginTop: 16 }} onClick={() => setShowCatModal(true)}>+ Add Category</button></div>
          ) : !items[activeCategory] || items[activeCategory].length === 0 ? (
            <div className="empty-state card"><h3>No items yet</h3><button className="btn btn-primary" style={{ marginTop: 16 }} onClick={openAddItem}>+ Add Item</button></div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {items[activeCategory].map(item => <ItemDisplay key={item.id} item={item} mobile={true} />)}
            </div>
          )}
        </div>
      ) : (
        /* DESKTOP */
        <div style={{ display: 'grid', gridTemplateColumns: '290px 1fr', gap: 20 }}>
          <div className="card" style={{ padding: 12, alignSelf: 'start' }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#757575', marginBottom: 10, padding: '0 8px' }}>CATEGORIES</div>
            {categories.length === 0 ? (
              <div style={{ fontSize: 13, color: '#999', textAlign: 'center', padding: '20px 0' }}>No categories yet</div>
            ) : categories.map((cat, idx) => (
              <div
                key={cat.id}
                draggable
                onDragStart={() => { setDragIdx(idx); }}
                onDragOver={e => { e.preventDefault(); setDragOverIdx(idx); }}
                onDrop={e => { e.preventDefault(); reorderCats(dragIdx, idx); setDragIdx(null); setDragOverIdx(null); }}
                onDragEnd={() => { setDragIdx(null); setDragOverIdx(null); }}
                onContextMenu={e => {
                  e.preventDefault();
                  setActiveCategory(cat.id);
                  setCatCtxMenu({ catId: cat.id, x: e.clientX, y: e.clientY });
                }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6, marginBottom: 3,
                  borderRadius: 8,
                  background:
                    dragOverIdx === idx && dragIdx !== idx ? '#E3F2FD'
                    : activeCategory === cat.id ? '#E3F2FD'
                    : cat.slide_only ? '#EEF2F4'
                    : 'transparent',
                  opacity: dragIdx === idx ? 0.4 : 1,
                  border:
                    dragOverIdx === idx && dragIdx !== idx ? '1.5px dashed #90CAF9'
                    : activeCategory === cat.id ? '1.5px solid transparent'
                    : cat.slide_only ? '1.5px dashed #B0BEC5'
                    : '1.5px solid transparent',
                  transition: 'background 0.1s, opacity 0.1s',
                }}
              >
                {/* Drag handle */}
                <div style={{ cursor: 'grab', color: '#C8C8C8', fontSize: 14, padding: '6px 2px 6px 6px', flexShrink: 0, userSelect: 'none' }}>
                  ☰
                </div>
                {/* Category cover thumbnail (or placeholder).
                    Click it to upload/replace the cover photo (same UX as
                    item thumbnails). The full-row click on the name still
                    selects the category — propagation is stopped here so a
                    cover-upload click doesn't also navigate. */}
                <div
                  onClick={(e) => handleQuickCatCoverClick(cat, e)}
                  style={{
                    width: 36, height: 36, borderRadius: 6, flexShrink: 0,
                    cursor: quickCatCoverUploading.has(cat.id) ? 'wait' : 'pointer',
                    background: cat.cover_image ? `url(${cat.cover_image}) center/cover` : '#F1F5F9',
                    border: '1px solid #E0E0E0',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    color: '#9CA3AF', fontSize: 14, position: 'relative',
                    opacity: quickCatCoverUploading.has(cat.id) ? 0.55 : 1,
                    transition: 'opacity 0.15s',
                  }}
                  title={
                    quickCatCoverUploading.has(cat.id)
                      ? 'Uploading cover…'
                      : (cat.cover_image ? 'Click to change cover photo' : 'Click to upload cover photo')
                  }
                  onMouseOver={e => { e.currentTarget.style.boxShadow = '0 0 0 2px #BBDEFB'; }}
                  onMouseOut={e => { e.currentTarget.style.boxShadow = 'none'; }}
                >
                  {!cat.cover_image && (cat.is_offer ? '🏷️' : '🍽')}
                  {quickCatCoverUploading.has(cat.id) && (
                    <span style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, background: 'rgba(255,255,255,0.65)', borderRadius: 6 }}>⏳</span>
                  )}
                </div>
                {/* Category name — click to select, right-click for options */}
                <div
                  onClick={() => setActiveCategory(cat.id)}
                  style={{ flex: 1, minWidth: 0, padding: '6px 6px 6px 0', cursor: 'pointer', color: activeCategory === cat.id ? '#2196F3' : '#333', fontWeight: activeCategory === cat.id ? 600 : 500, fontSize: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 6 }}
                >
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: 'Cairo, sans-serif', flex: 1, minWidth: 0, lineHeight: 1.3 }}>
                    {displayLang === 'ar' ? (cat.name_ar || cat.name) : cat.name}
                  </span>
                  {cat.slide_only && (
                    <span title="Slide-builder only — hidden from public QR menu"
                      style={{ fontSize: 9, background: '#CFD8DC', color: '#37474F',
                               borderRadius: 10, padding: '2px 6px', flexShrink: 0,
                               fontWeight: 700, letterSpacing: 0.3 }}>
                      📺 SLIDE
                    </span>
                  )}
                  <span style={{ fontSize: 10, background: activeCategory === cat.id ? '#BBDEFB' : '#eee', color: activeCategory === cat.id ? '#1565C0' : '#666', borderRadius: 10, padding: '2px 6px', flexShrink: 0, fontWeight: 600 }}>
                    {items[cat.id]?.length || 0}
                  </span>
                </div>
              </div>
            ))}
            {/* Category action toolbar */}
            <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: 10, paddingTop: 10, borderTop: '1px solid #F0F0F0' }}>
              <IcoBtn title="Add new category" onClick={() => { setShowCatModal(true); setCatForm({ name: '', name_ar: '', slide_only: false }); }}><PlusIco/></IcoBtn>
              <IcoBtn title="Add offer category (scrolling banner)" onClick={handleCreateOffer} style={{ color: '#E65100', fontSize: 15 }}>🏷️</IcoBtn>
              <IcoBtn title="Edit category" disabled={!activeCategory} onClick={openEditCat}><EditIco/></IcoBtn>
              <IcoBtn title="Duplicate category" disabled={!activeCategory} onClick={() => handleDuplicateCategory(activeCategory)}><CopyIco/></IcoBtn>
              <IcoBtn title="Delete category" disabled={!activeCategory} danger onClick={() => handleDeleteCategory(activeCategory)}><TrashIco/></IcoBtn>
            </div>
          </div>

          <div>
            {activeCategory ? (
              <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
                  <div>
                    <span style={{ fontWeight: 600, fontSize: 16, fontFamily: 'Cairo, sans-serif' }}>
                      {displayLang === 'ar' ? (activeCat?.name_ar || activeCat?.name) : activeCat?.name}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    <button
                      onClick={handleCreateOffer}
                      title="Create an offer category shown as a scrolling banner on the public menu"
                      style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 14px', borderRadius: 8, border: '1.5px solid #F9A825', background: '#FFF8E1', color: '#E65100', fontWeight: 600, fontSize: 13, cursor: 'pointer', transition: 'all 0.15s', whiteSpace: 'nowrap' }}
                      onMouseOver={e => { e.currentTarget.style.background = '#FFE082'; e.currentTarget.style.borderColor = '#F57F17'; }}
                      onMouseOut={e => { e.currentTarget.style.background = '#FFF8E1'; e.currentTarget.style.borderColor = '#F9A825'; }}
                    >
                      🏷️ Add Offer
                    </button>
                    <button className="btn btn-primary btn-sm" onClick={openAddItem}>+ Add Item</button>
                  </div>
                </div>
                {!items[activeCategory] || items[activeCategory].length === 0 ? (
                  <div className="empty-state card"><h3>No items yet</h3><button className="btn btn-primary" style={{ marginTop: 16 }} onClick={openAddItem}>+ Add Item</button></div>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {items[activeCategory].map((item, idx) => (
                      <div
                        key={item.id}
                        draggable
                        onDragStart={() => setItemDragIdx(idx)}
                        onDragOver={e => { e.preventDefault(); setItemDragOverIdx(idx); }}
                        onDrop={e => { e.preventDefault(); reorderItems(itemDragIdx, idx); setItemDragIdx(null); setItemDragOverIdx(null); }}
                        onDragEnd={() => { setItemDragIdx(null); setItemDragOverIdx(null); }}
                        style={{
                          opacity: itemDragIdx === idx ? 0.4 : 1,
                          borderRadius: 14,
                          outline: itemDragOverIdx === idx && itemDragIdx !== idx ? '2px dashed #90CAF9' : '2px solid transparent',
                          transition: 'opacity 0.15s, outline 0.1s',
                        }}
                      >
                        <ItemDisplay item={item} mobile={false} />
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : (
              <div className="empty-state card">
                <h3>No categories yet</h3>
                <p>Create a category first</p>
                <button className="btn btn-primary" style={{ marginTop: 16 }} onClick={() => setShowCatModal(true)}>+ Add Category</button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Add Category Modal */}
      {showCatModal && (
        <div className="modal-overlay" onClick={() => setShowCatModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">Add Category</span>
              <button className="modal-close" onClick={() => setShowCatModal(false)}>✕</button>
            </div>
            <form onSubmit={handleAddCategory}>
              <div className="input-group"><label>Name (English)</label><input className="input" value={catForm.name} onChange={e => setCatForm({...catForm, name: e.target.value})} placeholder="e.g. Main Dishes" autoFocus /></div>
              <div className="input-group"><label>Name (Arabic)</label><input className="input arabic" value={catForm.name_ar} onChange={e => setCatForm({...catForm, name_ar: e.target.value})} placeholder="مثال: وجبات رئيسية" /></div>
              <div className="input-group" style={{ marginTop: 6 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}>
                  <input
                    type="checkbox"
                    checked={!!catForm.slide_only}
                    onChange={e => setCatForm({ ...catForm, slide_only: e.target.checked })}
                    style={{ width: 16, height: 16, accentColor: '#1565C0', margin: 0 }}
                  />
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>
                    📺 Slide-only category
                  </span>
                </label>
                <div style={{ fontSize: 11, color: '#888', marginTop: 4, paddingLeft: 24 }}>
                  Show this category inside the Slide Builder's item picker only —
                  hide it from the public QR menu.
                </div>
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>Add Category</button>
            </form>
          </div>
        </div>
      )}

      {/* ── Right-click context menu on a category ── */}
      {catCtxMenu && (() => {
        // Clamp menu position to viewport so it doesn't overflow
        const W = 180, H = 168;
        const x = Math.min(catCtxMenu.x, window.innerWidth - W - 8);
        const y = Math.min(catCtxMenu.y, window.innerHeight - H - 8);
        const Item = ({ icon, label, danger, onClick: oc }) => (
          <button onClick={() => { setCatCtxMenu(null); oc(); }}
            style={{
              display: 'flex', alignItems: 'center', gap: 10, width: '100%',
              padding: '8px 14px', border: 'none', background: 'transparent',
              cursor: 'pointer', fontSize: 13, color: danger ? '#C62828' : '#222',
              textAlign: 'left', fontFamily: 'inherit',
            }}
            onMouseOver={e => e.currentTarget.style.background = danger ? '#FEF2F2' : '#F5F5F5'}
            onMouseOut={e => e.currentTarget.style.background = 'transparent'}
          >
            <span style={{ fontSize: 14, width: 18, textAlign: 'center' }}>{icon}</span>
            <span style={{ fontWeight: 500 }}>{label}</span>
          </button>
        );
        return (
          <div onClick={e => e.stopPropagation()}
            onContextMenu={e => e.preventDefault()}
            style={{
              position: 'fixed', top: y, left: x, zIndex: 9999,
              minWidth: W, background: '#fff',
              border: '1px solid #E0E0E0', borderRadius: 10,
              boxShadow: '0 8px 28px rgba(0,0,0,0.18)',
              padding: '4px 0',
            }}
          >
            <Item icon="✎"  label="Edit"      onClick={openEditCat} />
            <Item icon="⧉"  label="Duplicate" onClick={() => handleDuplicateCategory(catCtxMenu.catId)} />
            <div style={{ height: 1, background: '#F0F0F0', margin: '4px 0' }} />
            <Item icon="🗑" label="Delete"    danger onClick={() => handleDeleteCategory(catCtxMenu.catId)} />
          </div>
        );
      })()}

      {/* Edit Category Modal */}
      {showEditCatModal && (
        <div className="modal-overlay" onClick={() => setShowEditCatModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">Edit Category</span>
              <button className="modal-close" onClick={() => setShowEditCatModal(false)}>✕</button>
            </div>
            <form onSubmit={handleEditCategory}>
              <div className="input-group"><label>Name (English)</label><input className="input" value={editCatForm.name} onChange={e => setEditCatForm({...editCatForm, name: e.target.value})} autoFocus /></div>
              <div className="input-group"><label>Name (Arabic)</label><input className="input arabic" value={editCatForm.name_ar} onChange={e => setEditCatForm({...editCatForm, name_ar: e.target.value})} placeholder="اسم بالعربي" /></div>

              {/* Category cover photo — used as the tile background in the public-menu Grid view */}
              <div className="input-group">
                <label>Cover Photo <span style={{ fontSize: 11, color: '#888', fontWeight: 400 }}>(used in Grid menu view)</span></label>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {editCatForm.cover_image ? (
                    <div style={{ position: 'relative', flexShrink: 0 }}>
                      <img src={editCatForm.cover_image} alt="cover"
                        style={{ width: 84, height: 56, objectFit: 'cover', borderRadius: 8, border: '1.5px solid #E0E0E0' }} />
                      <button type="button"
                        onClick={() => setEditCatForm(f => ({ ...f, cover_image: '' }))}
                        title="Remove cover"
                        style={{ position: 'absolute', top: -7, right: -7, width: 18, height: 18, borderRadius: '50%', background: '#EF4444', border: 'none', color: '#fff', fontSize: 10, fontWeight: 700, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, padding: 0 }}>✕</button>
                    </div>
                  ) : (
                    <div style={{ width: 84, height: 56, borderRadius: 8, border: '1.5px dashed #D0D7DE', background: '#F8FAFB', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9CA3AF', fontSize: 11, flexShrink: 0 }}>
                      No cover
                    </div>
                  )}
                  <label className="btn" style={{ cursor: editCatUploading ? 'wait' : 'pointer', background: '#E3F2FD', color: '#1565C0', border: '1.5px solid #1565C0', fontSize: 13, fontWeight: 600, padding: '6px 14px', borderRadius: 7 }}>
                    {editCatUploading ? 'Uploading…' : (editCatForm.cover_image ? '⟳ Change' : '+ Upload')}
                    <input type="file" accept="image/*" style={{ display: 'none' }}
                      disabled={editCatUploading}
                      onChange={handleEditCatCoverUpload} />
                  </label>
                </div>
              </div>

              <div className="input-group" style={{ marginTop: 6 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', userSelect: 'none' }}>
                  <input
                    type="checkbox"
                    checked={!!editCatForm.slide_only}
                    onChange={e => setEditCatForm({ ...editCatForm, slide_only: e.target.checked })}
                    style={{ width: 16, height: 16, accentColor: '#1565C0', margin: 0 }}
                  />
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>
                    📺 Slide-only category
                  </span>
                </label>
                <div style={{ fontSize: 11, color: '#888', marginTop: 4, paddingLeft: 24 }}>
                  Show this category inside the Slide Builder's item picker only —
                  hide it from the public QR menu.
                </div>
              </div>

              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>Save Changes</button>
            </form>
          </div>
        </div>
      )}

      {/* Move / Copy Item Modal */}
      {showMoveModal && movingItem && (
        <div className="modal-overlay" onClick={() => { setShowMoveModal(false); setMovingItem(null); }}>
          <div className="modal" style={{ maxWidth: 400 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{moveCopyMode === 'move' ? 'Move Item' : 'Copy Item'}</span>
              <button className="modal-close" onClick={() => { setShowMoveModal(false); setMovingItem(null); }}>✕</button>
            </div>
            <div style={{ marginBottom: 12 }}>
              {/* Mode toggle */}
              <div style={{ display: 'flex', gap: 6, marginBottom: 14, background: '#F5F5F5', borderRadius: 10, padding: 4 }}>
                <button type="button"
                  onClick={() => setMoveCopyMode('move')}
                  style={{ flex: 1, height: 34, borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13, transition: 'all 0.15s',
                    background: moveCopyMode === 'move' ? '#fff' : 'transparent',
                    color: moveCopyMode === 'move' ? '#1565C0' : '#888',
                    boxShadow: moveCopyMode === 'move' ? '0 1px 4px rgba(0,0,0,0.10)' : 'none',
                  }}>
                  ↪ Move
                </button>
                <button type="button"
                  onClick={() => setMoveCopyMode('copy')}
                  style={{ flex: 1, height: 34, borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 13, transition: 'all 0.15s',
                    background: moveCopyMode === 'copy' ? '#fff' : 'transparent',
                    color: moveCopyMode === 'copy' ? '#2E7D32' : '#888',
                    boxShadow: moveCopyMode === 'copy' ? '0 1px 4px rgba(0,0,0,0.10)' : 'none',
                  }}>
                  ⎘ Copy
                </button>
              </div>
              <div style={{ fontSize: 13, color: '#757575', marginBottom: 10 }}>
                {moveCopyMode === 'move' ? 'Move' : 'Copy'} <strong>{movingItem.name_ar || movingItem.name}</strong> to:
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 320, overflowY: 'auto' }}>
                {categories.filter(c => moveCopyMode === 'copy' ? true : c.id !== activeCategory).map(cat => (
                  <button key={cat.id} type="button"
                    onClick={() => moveCopyMode === 'move' ? handleMoveItem(cat.id) : handleCopyItemTo(cat.id)}
                    disabled={moveCopyMode === 'move' && cat.id === activeCategory}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 10,
                      padding: '10px 14px', borderRadius: 10,
                      border: `1.5px solid ${cat.id === activeCategory ? '#BFDBFE' : '#E0E0E0'}`,
                      background: cat.id === activeCategory ? '#EFF6FF' : '#FAFAFA',
                      cursor: moveCopyMode === 'move' && cat.id === activeCategory ? 'default' : 'pointer',
                      textAlign: 'left', width: '100%', transition: 'all 0.12s',
                      opacity: moveCopyMode === 'move' && cat.id === activeCategory ? 0.45 : 1,
                    }}
                    onMouseOver={e => { if (!(moveCopyMode === 'move' && cat.id === activeCategory)) { e.currentTarget.style.background = moveCopyMode === 'copy' ? '#E8F5E9' : '#E3F2FD'; e.currentTarget.style.borderColor = moveCopyMode === 'copy' ? '#A5D6A7' : '#90CAF9'; }}}
                    onMouseOut={e => { e.currentTarget.style.background = cat.id === activeCategory ? '#EFF6FF' : '#FAFAFA'; e.currentTarget.style.borderColor = cat.id === activeCategory ? '#BFDBFE' : '#E0E0E0'; }}
                  >
                    {cat.icon && <span style={{ fontSize: 18 }}>{cat.icon}</span>}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600, fontSize: 14, color: '#1A1A1A' }}>{cat.name}</div>
                      {cat.name_ar && <div style={{ fontSize: 12, color: '#999', fontFamily: 'Cairo' }}>{cat.name_ar}</div>}
                    </div>
                    {cat.id === activeCategory && <span style={{ fontSize: 10, color: '#3B82F6', fontWeight: 600 }}>current</span>}
                    <span style={{ fontSize: 12, color: '#bbb', background: '#eee', borderRadius: 10, padding: '2px 8px' }}>{items[cat.id]?.length || 0}</span>
                  </button>
                ))}
                {categories.length === 0 && (
                  <div style={{ textAlign: 'center', color: '#999', padding: '20px 0', fontSize: 14 }}>No categories available</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Item Modal */}
      {showItemModal && (
        <div className="modal-overlay" onClick={() => { clearPendingFile(); setShowItemModal(false); setShowEmojiPicker(false); }}>
          <div className="modal" style={{ maxWidth: 560 }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editingItem ? 'Edit Item' : 'Add Item'}</span>
              <button className="modal-close" onClick={() => { clearPendingFile(); setShowItemModal(false); setShowEmojiPicker(false); }}>✕</button>
            </div>
            <form onSubmit={handleAddItem}>
              <div className="input-group"><label>Name (English)</label><input className="input" value={itemForm.name} onChange={e => setItemForm({...itemForm, name: e.target.value})} placeholder="e.g. Grilled Chicken" /></div>
              <div className="input-group"><label>Name (Arabic)</label><input className="input arabic" value={itemForm.name_ar} onChange={e => setItemForm({...itemForm, name_ar: e.target.value})} placeholder="دجاج مشوي" /></div>
              <div className="input-group"><label>Description</label><input className="input" value={itemForm.description} onChange={e => setItemForm({...itemForm, description: e.target.value})} placeholder="Short description..." /></div>
              <div className="input-group"><label>Description (Arabic)</label><input className="input arabic" value={itemForm.description_ar} onChange={e => setItemForm({...itemForm, description_ar: e.target.value})} placeholder="وصف قصير..." /></div>

              {/* Pricing */}
              <div style={{ background: '#f9f9f9', borderRadius: 10, padding: 14, marginBottom: 16, border: '1px solid #E0E0E0' }}>
                <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 12 }}>Pricing</div>

                {/* ── SIMPLE MODE ── */}
                {variantMode === 'simple' && (
                  <div>
                    <div className="input-group" style={{ marginBottom: 12 }}>
                      <label>Price (EGP)</label>
                      <input className="input" type="number" value={variants[0].price} onChange={e => updateVariant(0, 'price', e.target.value)} placeholder="0" step="1" inputMode="numeric" />
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      {/* Same price card */}
                      <button type="button"
                        onClick={() => { setVariantMode('same'); setVariants([{ name: '', name_ar: '', price: '' }, { name: '', name_ar: '', price: '' }]); }}
                        style={{ padding: '12px 8px', borderRadius: 10, border: '1.5px dashed #BDBDBD', background: '#fff', cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s' }}
                        onMouseOver={e => { e.currentTarget.style.borderColor = '#2196F3'; e.currentTarget.style.background = '#E3F2FD'; }}
                        onMouseOut={e => { e.currentTarget.style.borderColor = '#BDBDBD'; e.currentTarget.style.background = '#fff'; }}>
                        <div style={{ fontSize: 20, marginBottom: 4 }}>📦</div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#333', marginBottom: 2 }}>Same Price</div>
                        <div style={{ fontSize: 10, color: '#999', lineHeight: 1.4 }}>Sizes with one price</div>
                      </button>
                      {/* Own price card */}
                      <button type="button"
                        onClick={() => { setVariantMode('diff'); setVariants([{ name: '', name_ar: '', price: '' }, { name: '', name_ar: '', price: '' }]); }}
                        style={{ padding: '12px 8px', borderRadius: 10, border: '1.5px dashed #BDBDBD', background: '#fff', cursor: 'pointer', textAlign: 'center', transition: 'all 0.15s' }}
                        onMouseOver={e => { e.currentTarget.style.borderColor = '#43A047'; e.currentTarget.style.background = '#E8F5E9'; }}
                        onMouseOut={e => { e.currentTarget.style.borderColor = '#BDBDBD'; e.currentTarget.style.background = '#fff'; }}>
                        <div style={{ fontSize: 20, marginBottom: 4 }}>💰</div>
                        <div style={{ fontSize: 12, fontWeight: 700, color: '#333', marginBottom: 2 }}>Own Price Each</div>
                        <div style={{ fontSize: 10, color: '#999', lineHeight: 1.4 }}>Price per variant</div>
                      </button>
                    </div>
                  </div>
                )}

                {/* ── SAME PRICE MODE ── */}
                {variantMode === 'same' && (
                  <div>
                    {/* Active mode badge */}
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#E3F2FD', border: '1px solid #90CAF9', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 600, color: '#1565C0', marginBottom: 10 }}>
                      📦 Same Price for all
                    </div>
                    {/* Column headers */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 34px', gap: 6, marginBottom: 4 }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#999', textTransform: 'uppercase', letterSpacing: 0.3 }}>Variant</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#999', fontFamily: 'Cairo', textAlign: 'right' }}>الاسم</div>
                      <div />
                    </div>
                    {/* Variant rows (names only) */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
                      {variants.map((v, i) => (
                        <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 34px', gap: 6, alignItems: 'center' }}>
                          <input className="input" value={v.name} onChange={e => updateVariant(i, 'name', e.target.value)} placeholder="e.g. Large" style={{ marginBottom: 0 }} />
                          <input className="input arabic" value={v.name_ar || ''} onChange={e => updateVariant(i, 'name_ar', e.target.value)} placeholder="كبير" style={{ marginBottom: 0 }} />
                          <button type="button" onClick={() => removeVariant(i)}
                            style={{ background: '#FFEBEE', border: 'none', borderRadius: 8, color: '#C62828', cursor: 'pointer', height: 40, width: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}>✕</button>
                        </div>
                      ))}
                    </div>
                    <button type="button" onClick={addVariant}
                      style={{ width: '100%', marginBottom: 12, padding: '6px', borderRadius: 8, border: '1.5px dashed #BDBDBD', background: 'transparent', color: '#888', cursor: 'pointer', fontSize: 12 }}>
                      + Add row
                    </button>
                    {/* Shared price */}
                    <div className="input-group" style={{ marginBottom: 10 }}>
                      <label>Price for all (EGP)</label>
                      <input className="input" type="number" value={sharedPrice} onChange={e => setSharedPrice(e.target.value)} placeholder="0" step="1" inputMode="numeric" />
                    </div>
                    {/* Footer links */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <button type="button" onClick={() => { setVariantMode('simple'); setVariants([{ name: '', name_ar: '', price: sharedPrice }]); setSharedPrice(''); }}
                        style={{ background: 'none', border: 'none', color: '#aaa', fontSize: 11, cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>← single price</button>
                      <button type="button" onClick={() => { setVariants(variants.map(v => ({ ...v, price: sharedPrice }))); setSharedPrice(''); setVariantMode('diff'); }}
                        style={{ background: 'none', border: 'none', color: '#2196F3', fontSize: 11, cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>switch to own price →</button>
                    </div>
                  </div>
                )}

                {/* ── DIFF PRICE MODE ── */}
                {variantMode === 'diff' && (
                  <div>
                    {/* Active mode badge */}
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 5, background: '#E8F5E9', border: '1px solid #A5D6A7', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 600, color: '#2E7D32', marginBottom: 10 }}>
                      💰 Price per variant
                    </div>
                    {/* Column headers */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 82px 34px', gap: 6, marginBottom: 4 }}>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#999', textTransform: 'uppercase', letterSpacing: 0.3 }}>Variant</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#999', fontFamily: 'Cairo', textAlign: 'right' }}>الاسم</div>
                      <div style={{ fontSize: 11, fontWeight: 600, color: '#999', textTransform: 'uppercase', letterSpacing: 0.3 }}>Price</div>
                      <div />
                    </div>
                    {/* Variant rows with prices */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 8 }}>
                      {variants.map((v, i) => (
                        <div key={i}>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 82px 34px', gap: 6, alignItems: 'center' }}>
                            <input className="input" value={v.name} onChange={e => updateVariant(i, 'name', e.target.value)} placeholder="e.g. Large" style={{ marginBottom: 0 }} />
                            <input className="input arabic" value={v.name_ar || ''} onChange={e => updateVariant(i, 'name_ar', e.target.value)} placeholder="كبير" style={{ marginBottom: 0 }} />
                            <input className="input" type="number" value={v.price} onChange={e => updateVariant(i, 'price', e.target.value)} placeholder="0" step="1" inputMode="numeric" style={{ marginBottom: 0 }} />
                            <button type="button" onClick={() => removeVariant(i)}
                              style={{ background: '#FFEBEE', border: 'none', borderRadius: 8, color: '#C62828', cursor: 'pointer', height: 40, width: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}>✕</button>
                          </div>
                          {(v.name || v.name_ar) && !(v.name && v.name_ar) && (
                            <button type="button"
                              onClick={async () => {
                                const source = v.name ? v.name : v.name_ar;
                                const sourceLang = v.name ? 'en' : 'ar';
                                const targetLang = v.name ? 'ar' : 'en';
                                try {
                                  const res = await api.post('/translate/translate-menu', {
                                    categories: [],
                                    items: [{ id: 'temp', name: sourceLang === 'en' ? source : '', name_ar: sourceLang === 'ar' ? source : '' }]
                                  });
                                  if (res.data.success && res.data.items[0]) {
                                    const translated = targetLang === 'ar' ? res.data.items[0].name_ar : res.data.items[0].name;
                                    updateVariant(i, targetLang === 'ar' ? 'name_ar' : 'name', translated);
                                  }
                                } catch (err) { console.error('Translation failed:', err); }
                              }}
                              style={{ background: 'none', border: 'none', color: '#2196F3', cursor: 'pointer', fontSize: 11, padding: '2px 0', marginTop: 2, textDecoration: 'underline' }}>
                              🌐 Translate to {v.name ? 'Arabic' : 'English'}
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                    <button type="button" onClick={addVariant}
                      style={{ width: '100%', marginBottom: 10, padding: '6px', borderRadius: 8, border: '1.5px dashed #BDBDBD', background: 'transparent', color: '#888', cursor: 'pointer', fontSize: 12 }}>
                      + Add row
                    </button>
                    {/* Footer links */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <button type="button" onClick={() => { setVariantMode('simple'); setVariants([{ name: '', name_ar: '', price: variants[0]?.price || '' }]); setSharedPrice(''); }}
                        style={{ background: 'none', border: 'none', color: '#aaa', fontSize: 11, cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>← single price</button>
                      <button type="button" onClick={() => { const p = variants[0]?.price || ''; setSharedPrice(p); setVariants(variants.map(v => ({ ...v, price: '' }))); setVariantMode('same'); }}
                        style={{ background: 'none', border: 'none', color: '#2196F3', fontSize: 11, cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>switch to same price →</button>
                    </div>
                  </div>
                )}
              </div>

              {/* Photo / Icon section */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 14, fontWeight: 500, color: '#757575', display: 'block', marginBottom: 8 }}>Item Visual</label>

                {/* Toggle buttons */}
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  <button type="button" onClick={() => { setPhotoMode('file'); setShowEmojiPicker(false); }}
                    style={{ flex: 1, padding: '10px', borderRadius: 8, border: `2px solid ${photoMode === 'file' ? '#2196F3' : '#E0E0E0'}`, background: photoMode === 'file' ? '#E3F2FD' : '#fff', color: photoMode === 'file' ? '#2196F3' : '#555', fontWeight: photoMode === 'file' ? 600 : 400, cursor: 'pointer', fontSize: 14 }}>
                    📷 Upload Photo
                  </button>
                  <button type="button" onClick={() => { setPhotoMode('icon'); setShowEmojiPicker(true); }}
                    style={{ flex: 1, padding: '10px', borderRadius: 8, border: `2px solid ${photoMode === 'icon' ? '#2196F3' : '#E0E0E0'}`, background: photoMode === 'icon' ? '#E3F2FD' : '#fff', color: photoMode === 'icon' ? '#2196F3' : '#555', fontWeight: photoMode === 'icon' ? 600 : 400, cursor: 'pointer', fontSize: 14 }}>
                    😊 Choose Icon
                  </button>
                </div>

                {/* Upload photo */}
                {photoMode === 'file' && (
                  <div>
                    <style>{`@keyframes _imgSpin { to { transform: rotate(360deg); } }`}</style>
                    <input type="file" accept="image/*" onChange={handleImageUpload} className="input" style={{ padding: 10, opacity: uploading ? 0.5 : 1, pointerEvents: uploading ? 'none' : 'auto' }} />
                    {uploading ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
                        <div style={{ width: 64, height: 64, borderRadius: 8, background: '#F0F4FF', border: '2px solid #E3F2FD', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <div style={{ width: 26, height: 26, borderRadius: '50%', border: '3px solid #BBDEFB', borderTopColor: '#2196F3', animation: '_imgSpin 0.75s linear infinite' }} />
                        </div>
                        <span style={{ fontSize: 13, color: '#2196F3', fontWeight: 500 }}>Uploading…</span>
                      </div>
                    ) : (previewUrl || itemForm.image_path) ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 8 }}>
                        <img src={previewUrl || itemForm.image_thumb || itemForm.image_path} alt="preview" style={{ width: 64, height: 64, objectFit: 'contain', borderRadius: 8, background: '#f5f5f5' }} />
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => { clearPendingFile(); setItemForm(f => ({ ...f, image_path: '', image_thumb: '' })); }}>Remove</button>
                      </div>
                    ) : null}
                  </div>
                )}

                {/* Icon picker */}
                {photoMode === 'icon' && (
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                      {itemForm.icon ? (
                        <div style={{ width: 52, height: 52, borderRadius: 10, background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 32, border: '2px solid #2196F3' }}>
                          {itemForm.icon}
                        </div>
                      ) : (
                        <div style={{ width: 52, height: 52, borderRadius: 10, background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, color: '#ccc', border: '2px dashed #E0E0E0' }}>
                          🍽
                        </div>
                      )}
                      <div>
                        <div style={{ fontWeight: 500, fontSize: 14 }}>{itemForm.icon ? 'Icon selected' : 'No icon selected'}</div>
                        <button type="button" style={{ background: 'none', border: 'none', color: '#2196F3', cursor: 'pointer', fontSize: 13, padding: 0 }} onClick={() => setShowEmojiPicker(!showEmojiPicker)}>
                          {showEmojiPicker ? 'Hide picker' : 'Open picker'}
                        </button>
                        {itemForm.icon && (
                          <button type="button" style={{ background: 'none', border: 'none', color: '#F44336', cursor: 'pointer', fontSize: 13, padding: 0, marginLeft: 10 }} onClick={() => setItemForm(f => ({ ...f, icon: '' }))}>Clear</button>
                        )}
                      </div>
                    </div>
                    {showEmojiPicker && (
                      <EmojiPicker
                        onSelect={(em) => { setItemForm(f => ({ ...f, icon: em, image_path: '' })); }}
                        onClose={() => setShowEmojiPicker(false)}
                      />
                    )}
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', gap: 20, marginBottom: 16 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, cursor: 'pointer' }}>
                  <input type="checkbox" checked={itemForm.is_available} onChange={e => setItemForm({...itemForm, is_available: e.target.checked})} style={{ width: 18, height: 18 }} />
                  Available
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, cursor: 'pointer' }}>
                  <input type="checkbox" checked={itemForm.is_special} onChange={e => setItemForm({...itemForm, is_special: e.target.checked})} style={{ width: 18, height: 18 }} />
                  Special
                </label>
              </div>

              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', fontSize: 16, padding: '14px' }}>
                {editingItem ? 'Save Changes' : 'Add Item'}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* ── Restore confirm modal ── */}
      {restorePending && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 18, padding: '28px 24px 22px', maxWidth: 400, width: '100%', boxShadow: '0 12px 48px rgba(0,0,0,0.22)' }}>
            <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 10 }}>📂</div>
            <h3 style={{ margin: '0 0 6px', fontSize: 17, fontWeight: 700, textAlign: 'center' }}>Restore from Backup?</h3>
            <p style={{ margin: '0 0 14px', fontSize: 13, color: '#777', textAlign: 'center' }}>This backup file contains:</p>
            <div style={{ background: '#F8F8F8', borderRadius: 10, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>
              <div><strong>Brand:</strong> {restorePending.brand_name || '—'}</div>
              <div><strong>Date:</strong> {restorePending.timestamp ? new Date(restorePending.timestamp).toLocaleString() : '—'}</div>
              <div><strong>Contents:</strong> {restorePending.summary?.categories ?? restorePending.menu?.categories?.length ?? '?'} categories · {restorePending.summary?.items ?? '?'} items</div>
            </div>
            <div style={{ background: '#FFF5F5', border: '1px solid #FFCDD2', borderRadius: 10, padding: '10px 14px', marginBottom: 20, fontSize: 13, color: '#B71C1C' }}>
              ⚠️ This will <strong>permanently replace</strong> the current menu. Cannot be undone.
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={() => setRestorePending(null)} style={{ flex: 1, padding: '11px', borderRadius: 10, border: '1.5px solid #E0E0E0', background: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>Cancel</button>
              <button onClick={handleRestoreConfirm} style={{ flex: 1, padding: '11px', borderRadius: 10, border: 'none', background: '#EF4444', color: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>✅ Restore Menu</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Import-mode chooser modal (Replace vs Add) ── */}
      {showImportModeDialog && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 18, padding: '26px 24px 22px', maxWidth: 460, width: '100%', boxShadow: '0 12px 48px rgba(0,0,0,0.22)' }}>
            <div style={{ fontSize: 40, textAlign: 'center', marginBottom: 8 }}>📊</div>
            <h3 style={{ margin: '0 0 6px', fontSize: 17, fontWeight: 700, textAlign: 'center' }}>Import from Excel</h3>
            <p style={{ margin: '0 0 18px', fontSize: 13, color: '#777', textAlign: 'center', lineHeight: 1.5 }}>
              How should the imported items be applied to your menu?
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
              {/* Add option (default, safe) */}
              <button onClick={() => confirmImportMode(true)}
                style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', borderRadius: 12, border: '1.5px solid #C8E6C9', background: '#F1F8E9', cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s' }}
                onMouseOver={e => { e.currentTarget.style.background = '#E8F5E9'; e.currentTarget.style.borderColor = '#81C784'; }}
                onMouseOut={e => { e.currentTarget.style.background = '#F1F8E9'; e.currentTarget.style.borderColor = '#C8E6C9'; }}>
                <span style={{ fontSize: 28, flexShrink: 0 }}>➕</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#1B5E20' }}>Add to existing menu</div>
                  <div style={{ fontSize: 12, color: '#33691E', marginTop: 2, lineHeight: 1.4 }}>Keeps current categories &amp; items. New rows are appended; matching names are updated.</div>
                </div>
              </button>
              {/* Replace option (destructive) */}
              <button onClick={() => confirmImportMode(false)}
                style={{ display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px', borderRadius: 12, border: '1.5px solid #FFCDD2', background: '#FFEBEE', cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s' }}
                onMouseOver={e => { e.currentTarget.style.background = '#FFCDD2'; e.currentTarget.style.borderColor = '#EF9A9A'; }}
                onMouseOut={e => { e.currentTarget.style.background = '#FFEBEE'; e.currentTarget.style.borderColor = '#FFCDD2'; }}>
                <span style={{ fontSize: 28, flexShrink: 0 }}>🗑️</span>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#B71C1C' }}>Replace entire menu</div>
                  <div style={{ fontSize: 12, color: '#C62828', marginTop: 2, lineHeight: 1.4 }}>⚠️ Deletes ALL current categories &amp; items first, then imports fresh. Cannot be undone.</div>
                </div>
              </button>
            </div>
            <button onClick={() => setShowImportModeDialog(false)}
              style={{ width: '100%', padding: '11px', borderRadius: 10, border: '1.5px solid #E0E0E0', background: '#fff', cursor: 'pointer', fontSize: 14, fontWeight: 600, color: '#555' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* Per-item dropdown rendered into document.body via portal — escapes ALL stacking contexts */}
      {openItemMenuId && itemMenuData && ReactDOM.createPortal(
        <>
          <div
            style={{ position: 'fixed', inset: 0, zIndex: 9998 }}
            onClick={() => { setOpenItemMenuId(null); setItemMenuData(null); }}
          />
          <div
            onClick={e => e.stopPropagation()}
            style={{
              position: 'fixed',
              ...(itemMenuPos.openAbove
                ? { bottom: itemMenuPos.bottom }
                : { top:    itemMenuPos.top    }),
              right: itemMenuPos.right,
              zIndex: 9999,
              background: '#fff',
              border: '1.5px solid #E8E8E8',
              borderRadius: 12,
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              padding: '4px 0',
              minWidth: 210,
            }}
          >
            {[
              { icon: <EditIco />,   label: 'Edit',             action: () => openEditItem(itemMenuData) },
              { icon: <CopyIco />,   label: 'Duplicate',        action: () => handleDuplicateItem(itemMenuData.id) },
              { icon: <CopyToIco />, label: 'Copy to category', action: () => { setMovingItem(itemMenuData); setMoveCopyMode('copy'); setShowMoveModal(true); } },
              { icon: <MoveIco />,   label: 'Move to category', action: () => { setMovingItem(itemMenuData); setMoveCopyMode('move'); setShowMoveModal(true); } },
            ].map(({ icon, label, action }) => (
              <button
                key={label}
                onClick={() => { setOpenItemMenuId(null); setItemMenuData(null); action(); }}
                style={{
                  width: 'calc(100% - 6px)', margin: '1px 3px', padding: '9px 12px',
                  border: 'none', background: 'none', borderRadius: 7,
                  cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                  color: '#222', fontSize: 13, fontWeight: 500, textAlign: 'left',
                }}
                onMouseOver={e => e.currentTarget.style.background = '#F5F5F5'}
                onMouseOut={e => e.currentTarget.style.background = 'none'}
              >
                <span style={{ display: 'flex', width: 16, flexShrink: 0, color: '#666' }}>{icon}</span>
                {label}
              </button>
            ))}
            <div style={{ height: 1, background: '#F0F0F0', margin: '3px 0' }} />
            <button
              onClick={() => { setOpenItemMenuId(null); setItemMenuData(null); handleDeleteItem(itemMenuData.id); }}
              style={{
                width: 'calc(100% - 6px)', margin: '1px 3px', padding: '9px 12px',
                border: 'none', background: 'none', borderRadius: 7,
                cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                color: '#C62828', fontSize: 13, fontWeight: 500, textAlign: 'left',
              }}
              onMouseOver={e => e.currentTarget.style.background = '#FFF5F5'}
              onMouseOut={e => e.currentTarget.style.background = 'none'}
            >
              <span style={{ display: 'flex', width: 16, flexShrink: 0, color: '#C62828' }}><TrashIco /></span>
              Delete
            </button>
          </div>
        </>,
        document.body
      )}

    </div>
  );
}
